import React, { useState, useEffect } from 'react';
import InputField from '../../../../forms/inputField';
import { updateUser } from '../../../../../client/users';
import SelectSearch from '../../../../forms/selectSearch';
import { getSuppliers } from '../../../../../client/suppliers';
import { MODALS } from '../../../../../config/images';
const ModalEditProvider = ({ showModal, user, onClose, onSave, setSuccessMessage, setShowModalSuccess }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    charge: '',
    category: '',
    supplierId: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [loadingSuppliers, setLoadingSuppliers] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null); 

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        setLoadingSuppliers(true);
        const response = await getSuppliers();
        setSuppliers(response.data);
        setLoadingSuppliers(false);
      } catch (error) {
        console.error('Error al obtener proveedores:', error);
        setLoadingSuppliers(false);
      }
    };

    fetchSuppliers();
  }, []);

  const supplierOptions = suppliers.map(supplier => ({
    value: supplier.id.toString(),
    label: supplier.name
  }));


  useEffect(() => {
    if (user) {
      setFormData({
        fullName: user.fullName || '',
        phone: user.phone || '',
        charge: user.charge || '',
        category: user.category || '',
        supplierId: user.supplierId || ''
      });

      if (user.supplierId && suppliers.length > 0) {
        const foundSupplier = suppliers.find(s => s.id.toString() === user.supplierId.toString());
        if (foundSupplier) {
          setSelectedSupplier({
            value: foundSupplier.id.toString(),
            label: foundSupplier.name
          });
        }
      }
    }
  }, [user, suppliers]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSupplierChange = (selectedOption) => {
    setSelectedSupplier(selectedOption);

    setFormData(prev => ({
      ...prev,
      supplierId: selectedOption ? selectedOption.value : ''
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const updateData = {
        roleId: 2, 
        name: formData.fullName,
        contact_number: formData.phone ? parseInt(formData.phone) : null,
        charge: formData.charge || null,
        category: formData.category || null,
        supplierId: formData.supplierId ? parseInt(formData.supplierId) : null
      };


      const response = await updateUser(user.id, updateData);
      
      if (response.status === 200) {
        setSuccessMessage('Usuario proveedor actualizado correctamente');
        setShowModalSuccess(true);
        onSave();
        onClose();
      }
    } catch (err) {
      console.error('Error al actualizar usuario:', err);
      setError(err.response?.data?.message || 'Error al actualizar el usuario');
    } finally {
      setLoading(false);
    }
  };


  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-[90%] sm:w-[60%] md:w-[50%] lg:w-[50%] xl:w-[40%] h-[90vh] overflow-y-auto bg-white rounded-2xl">
        <div className="flex justify-end w-full p-2 ">
          <button onClick={onClose} >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div className='px-6 pb-6'>
            <h2 className="text-2xl font-itcbold text-blue">Editar Usuario Proveedor</h2>
    
    
            <form onSubmit={handleSubmit} className="flex flex-col gap-2 pt-4">
            
            <div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
                    <InputField
                    title="Nombre completo"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    validation="letters-only"
                    placeholder="Ingrese nombre completo"
                    horizontal={false}
                    required={true}
                    />
                <InputField
                  title="Número de contacto"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  type="tel"
                  validation="phone"
                  placeholder="Ingrese número de contacto"
                  maxLength={9}
                  horizontal={false}
                />
    
                <InputField
                  title="Cargo"
                  name="charge"
                  value={formData.charge}
                  onChange={handleChange}
                  placeholder="Ingrese cargo"
                  horizontal={false}
                />
                
                <InputField
                  title="Categoría"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  placeholder="Ingrese categoría"
                  horizontal={false}
                />
    
                  <SelectSearch
                    title="Proveedor"
                    name="supplierId"
                    value={selectedSupplier}
                    onChange={handleSupplierChange}
                    options={supplierOptions}
                    placeholder="Seleccione proveedor"
                    isDisabled={loadingSuppliers}
                    isLoading={loadingSuppliers}
                    maxMenuHeight={100}
                    required={true}
                    horizontal={false}
                  />
            </div>
              
              <div className="flex items-center justify-center pt-12 space-x-3">
                <button
                  type="button"
                  onClick={onClose}
                  disabled={loading}
                  className="px-4 py-2 w-[120px] text-gray-700 border border-gray-300 rounded-md font-itcmedium hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-4 py-2 w-[120px] text-white rounded-md font-itcmedium bg-blue"
                >
                  {loading ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </form>
        </div>
      </div>
    </div>
  );
};

export default ModalEditProvider;